import React from 'react';
import { connect } from 'react-redux';

import SponsorshipListSummaryItem from '../../common/sponsorships/list/sponsorshipListSummaryItem';
import * as selectors from '../publication.selectors';
import { numberFormatter } from '../../common/formatter';
import { metricName } from '../../common/constants';


const capitalize = (text) => {
    return text.charAt(0).toUpperCase() + text.slice(1);
};

const currencyMetrics = {
    [metricName.cpc]: 'CPC',
    [metricName.cpm]: 'CPM'
};

const percentageMetrics = {
    [metricName.ctr]: 'CTR'
};

const PublicationListSummaryComponent = ({ recordTotal, priceTotal, metricNames, metricValues, isLoading}) => {

    if(isLoading) {
        return <span>Loading summary...</span>;
    }

    const summaryData = [
        { name: "Publications", value: numberFormatter.format(recordTotal) },
        { name: "Price", value: numberFormatter.formatAsCurrency(priceTotal, 0) }
    ];

    // Add metrics.
    for(let metricName of metricNames) {

        let metricDisplayName = capitalize(metricName);
        let metricValue = numberFormatter.format(metricValues[metricName], true);
        if(Object.keys(currencyMetrics).includes(metricName)) {
            metricDisplayName = currencyMetrics[metricName];
            metricValue = numberFormatter.formatAsCurrency(metricValues[metricName]);
        }

        if(Object.keys(percentageMetrics).includes(metricName)) {
            metricDisplayName = percentageMetrics[metricName];
            metricValue = numberFormatter.formatAsPercentage(metricValues[metricName]);
        }


        summaryData.push({
            name: metricDisplayName,
            value: metricValue
        });
    }

    let items = summaryData.map(summaryItem => <SponsorshipListSummaryItem key={summaryItem.name} name={summaryItem.name} value={summaryItem.value} />);

    return (
        <div className="summary-container">
            {items}
        </div>
    );
};

function mapStateToProps(state) {
    const totalsInfo = selectors.getTotalsInfo(state) || {};
    let priceTotal = 0;
    if(totalsInfo && Object.keys(totalsInfo).length > 0) {
        priceTotal = totalsInfo.price;
    }
    return {
        isLoading: selectors.isPublicationDataLoading(state),
        ...selectors.getPaginationInfo(state),
        priceTotal,
        metricNames: selectors.getAggregateMetricNames(state) || [],
        metricValues: selectors.getAggregateMetricValues(state)
    };
  }
  
const PublicationListSummary = connect(mapStateToProps)(PublicationListSummaryComponent);
export default PublicationListSummary;